var TscProgressLabelType = {
  count: 'count',
  percent: 'percent'
};
export default TscProgressLabelType;